// $(document).ready(function(){
//   $(".slick-prev").text('PREV');
//   $(".cart-text").text('Cart');
// });

// Product page Option selection
$(document).ready(function () {
  //   Testimonials
  $(".slider").slick({
    dots: true,
    arrows: false,
  });

  // Scroll Automatic
  if ($('[data-option-index="0"]', ".product-template").length) {
    $('[data-option-index="0"] .swatch-element label', ".product-template").on(
      "click",
      function () {
        //       $('html, body').animate({
        //         scrollTop: $('[data-option-index="0"]','.product-template').offset().top - $('.sticky-wrapper .wrapper-navigation').height() - 20
        //       }, 'slow')
        let element = document.getElementById("add-to-cart-form");
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    );
  }

  // Scroll Automatic to next step
  if ($('[data-option-index="1"]', ".product-template").length) {
    $('[data-option-index="1"] .swatch-element label', ".product-template").on(
      "click",
      function () {
        //       $('html, body').animate({
        //         scrollTop: $('[data-option-index="1"]','.product-template').offset().top - $('.sticky-wrapper .wrapper-navigation').height() - 20
        //       }, 'slow')

        let element = document.getElementById("add-to-cart-form");
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    );
  }

  // Sticky Image on desktop
  if (window.screen.width > 749) {
    $(".product-img-box").stick_in_parent({
      parent: $(".product_top.horizontal-tabs"),
      offset_top: $(".sticky-wrapper .wrapper-navigation").height(),
      inner_scrolling: false,
    });
  }

  //Slider for Offer Banner
  $(".offer-banner-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
    ],
  });
  //End of Slider

  //Slider for Valentine Hero Banner
  $(".valentine-hero-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
  });
  //End of Slider

  //Slider for Valentine Offer Banner
  $(".valentine-banner-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  //End of Slider

  $(document).on("click", ".btn-go-to-cart", function () {
    var ajaxCartModal = $(
      "[data-ajax-cart-success], [data-quickview-modal], [data-compare-modal], [data-compare-message-modal]"
    );
    ajaxCartModal.fadeOut(500, function () {
      html.removeClass("halo-modal-open");
      html.css({
        overflow: "",
      });
    });
    $("html").toggleClass("cart-show");
  });

   //Truncate Product Page Description
  $(".desc_toggle_btn").click(function () {
    $(this).toggleClass("active");
    $(".product-shop .short-description").toggleClass("active");

    if ($(".desc_toggle_btn").hasClass("active")) {
      $(".desc_toggle_text").text("Read less");
    } else {
      $(".desc_toggle_text").text("Read more");
    }
  });
  
  //Tortoise Button Integration on Product Page
  var tortoiseModalButton = document.getElementById("open-tortoise-modal");
  var tortoiseGlass = document.getElementById("tortoise-glass");

  tortoiseModalButton.addEventListener("click", function () {
    tortoiseGlass.style.display = "flex";
    document.body.classList.add("overflow-pop-hidden");
  });

  tortoiseGlass.addEventListener("click", function () {
    tortoiseGlass.style.display = "none";
    document.body.classList.remove("overflow-pop-hidden");
  });

 

  // Action and Function to Copy Discount Code on PDP
  $(".copyCode").click(function () {
    var element = $(this).attr("data");
    copyToClipboard($("." + element));
  });

  function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
  }

  if (window.location.href.indexOf("watch") > -1) {
    $(".coupon-code-container").show();
  }
  // End of Action and Function to Copy Discount Code on PDP
});

// $("#customer_login_link").text('Log in');
// $("#customer_register_link").text('Create your Account');

//Script for PDP Related Accessories 2 Snippet
function attatchCardListener(nodelist) {
  nodelist.forEach((card) => {
    card.addEventListener("click", (e) => {
      if (
        e.target.getAttribute("title") === "More Color" ||
        e.target.tagName === "LABEL" ||
        e.target.tagName === "A" ||
        e.target.classList.contains("related-product__title") ||
        e.target.tagName === "IMG"
      )
        return;
      card
        .querySelector(".related-products__selector input")
        .classList.toggle("selected");
      card.classList.toggle("selected");
    });
  });
}
const relatedProductsEl = document.querySelector(".related-products-section");
if (relatedProductsEl) {
  let cardEll = relatedProductsEl.querySelectorAll(".related-product__card");
  attatchCardListener(cardEll);
  let moreBtn = relatedProductsEl.querySelector(".related-products-accordion");
  moreBtn.addEventListener("click", () => {
    relatedProductsEl.classList.toggle("show-more");
  });
}

//Script for PDP Offer Products

const offerProductsEl = document.querySelector(".offer-products-section");
if (offerProductsEl) {
  let offerEll = offerProductsEl.querySelectorAll(".related-product__card");
  attatchCardListener(offerEll);
}

//Customized Mac ATC

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelector("#customproduct-add-to-cart")
    .addEventListener("click", function () {
      e.preventDefault();
      $(this).attr("disabled", "disabled");
      ella.showLoading();
      let selectedOptions = document.querySelectorAll(".option-selected");
      let linePropObj = {};
      selectedOptions.forEach((option) => {
        if (option.parentElement.querySelector(".option-title") != null) {
          let title =
            option.parentElement.querySelector(".option-title").textContent;
          linePropObj[title] = option.getAttribute("data-sku-value");
        }
      });
      let primaryVariantId = document.querySelector('[name="id"]').value;
      let formData = {
        items: [
          {
            id: primaryVariantId,
            quantity: 1,
            properties: linePropObj,
          },
        ],
      };
      let softwareAddOns = document.querySelectorAll(
        ".software-options.option-selected"
      );
      let scrap = [];
      softwareAddOns.forEach((el) =>
        scrap.push(el.getAttribute("data-variant-id"))
      );
      let softwareIds = scrap.filter((e) => e);
      softwareIds.forEach((id) => formData.items.push({ id: id, quantity: 1 }));
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }).then((response) => {
        var ajaxCartModal = $("[data-ajax-cart-success]"),
          modalContent = ajaxCartModal.find(".cart-modal-content");

        modalContent
          .find(".ajax-product-title")
          .html(ella.translateText(title));
        modalContent.find(".ajax-product-image").attr("src", image);
        modalContent.find(".message-added-cart").show();

        if ($("[data-quickview-modal]").is(":visible")) {
          $("[data-quickview-modal]").hide();
        }

        ella.closeLookbookModal();
        $("html").toggleClass("cart-show");

        ella.updateDropdownCart();
        if ($(".template-cart").length) {
          ella.loadAjaxCart();
        }

        ella.hideLoading();

        $(this).removeAttr("disabled");
      });
    });
});


